import { takeEvery, call, put, all, fork } from "redux-saga/effects";
import { actionCreators as actionCreatorsSpinner } from "../Spinner/action";
import {
  actionCreators,
  LOGIN,
  LOGOUT,
  SIGN_IN_WITH_GOOGLE,
  SIGN_IN_WITH_FACEBOOK,
  SING_IN_WITH_APPLE,
  REHYDRATE_AUTH,
} from "./action";
import { actionCreators as actionCreatorsForgotPassword } from "../ForgotPassword/action";
import { actionCreators as actionCreatorsTest } from "../../test/action";
import { actionCreators as actionCreatorsResults } from "../Results/action";
import reduxSagaFirebase from "../../common/reduxSagaFirebase";
// import firebase from "firebase/compat/app";
import routes from "../../routing/routes";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { actionCreators as actionCreatorsLanguage } from '../Language/action';

export function* onLoginSaga(action) {
  const email = action.payload.email;
  const password = action.payload.password;
  yield put(actionCreatorsSpinner.showSpinner());
  try {
    const data = yield call(
      reduxSagaFirebase.auth.signInWithEmailAndPassword,
      email,
      password
    );
    yield put(actionCreators.loginSuccess(data));
    const uid = data.user.uid;
    // TODO zrobić persist and rehydrate
    const dataString = JSON.stringify(data);
    yield call(AsyncStorage.setItem, "authUserData", dataString);

    const answers = yield call(
      reduxSagaFirebase.database.read,
      `answers/${uid}`
    );
    yield put(actionCreatorsTest.saveTest(answers));
    // yield put(actionCreators.presistAuth({email, password}));
    //yield call(actionCreatorsResults.fetchResult());
    yield call(action.payload.redirect, routes.Home);

    // TODO zrobić spinner ze aplikacja myśli
    yield put(actionCreatorsSpinner.hideSpinner());
  } catch (error) {
    yield put(actionCreatorsForgotPassword.saveErrorReponse(error));
    yield put(actionCreatorsSpinner.hideSpinner());
  }
}

// export function* onloginWithGoogleSaga(action) {
//   const authProvider = new firebase.auth.GoogleAuthProvider();

//   try {
//     const credential = yield call(
//       reduxSagaFirebase.auth.signInWithRedirect,
//       authProvider
//     );

//     const user = yield call(
//       reduxSagaFirebase.auth.signInWithCredential,
//       credential
//     );

//     yield put(actionCreators.loginSuccess({ ...credential, ...user }));
//     yield call(action.payload.redirect, routes.Home);
//   } catch (error) {
//     // console.log("blad", error);
//     yield put(actionCreators.loginFailure(error));
//   }

//   // const email = action.payload.email;
//   // const password = action.payload.password;

//   // yield put(actionCreators.spinnerOn());
//   // try {

//   // 	const data = yield call(reduxSagaFirebase.auth.signInWithEmailAndPassword, email, password);
//   // 	yield put(actionCreators.loginSuccess(data));
//   // 	yield put(actionCreators.presistAuth({email, password}));
//   // 	yield call(action.payload.redirect,"Home");
//   // 	// yield call(action.payload.redirect,"MonthlyBudgetSetup");
//   // 	yield put(actionCreators.spinnerOff());

//   // } catch (error) {
//   // 	yield put(actionCreatorsForgotPassword.saveErrorReponse(error));
//   // 	yield put(actionCreators.spinnerOff());
//   // }
// }

export function* onLoginWithFacebookSaga(action) {
  alert("saga w facebooczku :D");
}

export function* onLoginWithAppleSaga(action) {
  alert("Saga: Lubisz jabłka?");
}

export function* onlogOutSaga(action) {
  try {
    const data = yield call(reduxSagaFirebase.auth.signOut);

    yield call(action.payload, "LogOut");
  } catch (error) {
    yield call(alert, error);
  }
}

export function* onRehydrateAuthSaga(action) {
  const dataString = yield call(AsyncStorage.getItem, "authUserData");
  const data = JSON.parse(dataString);


  const language = yield call(AsyncStorage.getItem, "language");

  if (language !== null) {
    yield put(actionCreatorsLanguage.setLanguage(language));
  }

  // console.log(data)
  if (data !== null) {
    yield put(actionCreators.loginSuccess(data));
    yield call(action.payload.redirect, routes.Home);
  }

  
}

export function* logInSaga() {
  yield takeEvery(LOGIN, onLoginSaga);
}

// export function* logInWithGoogleSaga() {
//   yield takeEvery(SIGN_IN_WITH_GOOGLE, onloginWithGoogleSaga);
// }

export function* logInWithFacebookSaga() {
  yield takeEvery(SIGN_IN_WITH_FACEBOOK, onLoginWithFacebookSaga);
}

export function* logInWithAppleSaga() {
  yield takeEvery(SING_IN_WITH_APPLE, onLoginWithAppleSaga);
}

export function* logOutSaga() {
  yield takeEvery(LOGOUT, onlogOutSaga);
}

export function* rehydrateAuthSaga() {
  yield takeEvery(REHYDRATE_AUTH, onRehydrateAuthSaga);
}

export function* loginSaga() {
  yield all([
    fork(logInSaga),
    // fork(logInWithGoogleSaga),
    fork(logInWithFacebookSaga),
    fork(logInWithAppleSaga),
    fork(logOutSaga),
    fork(rehydrateAuthSaga),
  ]);
}
